import Layout from "@/layout/index.vue";
export default [
  {
    path: "/",
    name: "Exam",
    component: Layout,
    redirect: "/exam/info",
    children: [
      {
        path: "/exam/info",
        name: "ExamInfo",
        component: () => import("@/views/exam/info"),
      },
      {
        path: "/exam/testPaper",
        name: "TestPaper",
        component: () => import("@/views/exam/testPaper"),
      },
      {
        path: "/exam/examCenter",
        name: "ExamCenter",
        component: () => import("@/views/exam/examCenter"),
      },
      {
        path: "/exam/success",
        name: "Success",
        component: () => import("@/views/exam/success"),
      },
    ],
  },
];
